module.exports = __webpack_public_path__ + "img/default.2875934c.svg";